import React from 'react';

export function Spinners({spinners = []}) {
  let hasText = spinners.find(spinner => spinner.message);

  return spinners && spinners.length > 0 ? (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999,
        overflowY: 'auto',
        transition: 'background-color 0.2s linear 0s',
        backgroundColor: 'rgba(55, 56, 56, 0.6)',
        fontSize: '2rem',
      }}>
      <div>
        <div className={`spinner ${!!hasText && 'mb-10'}`} />

        {hasText &&
          spinners.map(spinner => (
            <div key={spinner.id} className="text-white text-16">
              {spinner.message}
            </div>
          ))}
      </div>
    </div>
  ) : null;
}
